export default __webpack_public_path__ + "static/media/btnDownload.e0b95126.png";